import Link from 'next/link';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';

//lib
import { REPORTS_EDIT } from '@/lib/routes/privateRoutes';

//components
import Icon from '@/components/base/Icon';

const ActionsCell = ({
    row,
    toggle = () => {
        /** */
    },
    setModalParams = () => {
        /** */
    }
}) => {
    const { t } = useTranslation('commons');
    const id = row?.cell?.row?.original?.id;

    return (
        <div className="flex items-center justify-center space-x-5 transition-all">
            <Link href={REPORTS_EDIT.replace('[id]', id)}>
                <>
                    <button className="flex items-center">
                        <Icon
                            icon="edit"
                            className="text-icoGray-500 hover:text-icoBlue dark:text-icoDarkMode-wolf dark:hover:text-icoBlue"
                        />
                    </button>
                </>
            </Link>
            <button
                className="flex items-center"
                onClick={() => {
                    setModalParams({ id });
                    toggle();
                }}
                title={t('delete')}>
                <Icon
                    icon="trash"
                    className="text-icoGray-500 hover:text-icoRed dark:text-icoDarkMode-wolf dark:hover:text-icoRed"
                />
            </button>
        </div>
    );
};

ActionsCell.propTypes = {
    row: PropTypes.object,
    toggle: PropTypes.func,
    setModalParams: PropTypes.func
};

export default ActionsCell;
